export const FAQ = [
  {
    id: 'asAdmin',
    points: 3,
  },
  {
    id: 'asSubAccount',
    points: 5,
  },
  {
    id: 'forgotPassword',
    points: 5,
  },
];
